import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewInvitesList = (invitesPayload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_INVITES_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/invite/list`,
        invitesPayload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_INVITES_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_INVITES_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add event");
      dispatch({
        type: "GET_INVITES_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getInviteData = (inviteData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_INVITE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/invite/view/${inviteData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_INVITE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_INVITE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_INVITE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const changeInviteStatus = (inviteData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "CHANGE_INVITE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/invite/accept-decline`,
        inviteData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "CHANGE_INVITE_SUCCESS", payload: data });
        toast.success("Changed Successfully!!");
      } else {
        dispatch({ type: "CHANGE_INVITE_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "CHANGE_INVITE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
